/**
 * The §D1 `GET /auth/me` boot call, as a component so it can sit inside the providers.
 * Renders nothing; all the behaviour is in `lib/session.ts`.
 */
import { useSessionQuery } from '../lib/session';

export function SessionSync(): null {
  useSessionQuery();
  return null;
}

export default SessionSync;
